<div class="row">
  <div class="columns small-12 medium-5">
    <form class="rs-form-neg">
      <div class="rs-form-item">
        <select
          id="billingAccountSelection"
          name="billingAccountSelection"
          class="rs-filled"
          [(ngModel)]="selectedAccountNumber"
          (ngModelChange)="onChangeOfAccountNumber($event)"
          data-tms-event="filter-click"
          data-tms-filter-zone="mybill.overview"
          [attr.data-tms-filter-name]="
            'address selector ' + selectedAccountNumber
          "
          data-cy="myBillSelectBillingAccount"
        >
          <option value="" selected="">
            {{ 'bills.accountsView.allAddresses' | translate }}
          </option>
          <option
            *ngFor="let billingAccount of billingAccounts"
            [value]="billingAccount.accountNumber"
            selected="selectedAccountNumber"
          >
            {{ getFormattedAddress(billingAccount) }}
          </option>
        </select>

        <label class="rs-form-label" for="billingAccountSelection">
          {{ 'bills.accountsView.showBillsFor' | translate }}
        </label>
      </div>
    </form>
  </div>
</div>
